import {
  ORG_GET_ORG,
  ORG_PROFILE_REQUEST,
  ORG_PROFILE_UPDATE,
  ORG_FREE_DATA,
  ORG_REGISTER_REQUEST,
  ORG_LIST_REQUEST,
  ORG_SET_ORG,
  ORG_TYPES_REQUEST,
  ORG_FORMS_REQUEST,
  ORG_GET_STRUCTURE,
  ORG_CLEAR_STRUCTURE,
  ORG_GET_DIV_USERS,
  ORG_GET_TECHADMINS,
  ORG_GET_DIVISION_LIST,
  ORG_ADD_DIVISION,
  ORG_UPD_DIVISION,
  ORG_SET_DIVISION,
  ORG_DEL_DIVISION,
  ORG_SET_USER,
  ORG_GET_POSITIONS,
  ORG_ADD_POSITION,
  ORG_UPD_POSITION,
  ORG_DEL_POSITION,
  ORG_ADD_EMPLOEE,
  ORG_UPD_EMPLOEE,
  ORG_LOCK_EMPLOEE,
  ORG_MOVE_EMPLOEE,
  ORG_SEND_CREDENTIALS,
  ORG_ADD_USER_CONTACT,
  ORG_UPD_USER_CONTACT,
  ORG_DEL_USER_CONTACT,
  ORG_ADD_USER_ROLE,
  ORG_UPD_USER_ROLE,
  ORG_SET_USER_CONTACT_MAIN,
  ORG_SET_PO_USER,
  ORG_LOCK_PO_USER,
  ORG_GET_DEPTS,
  ORG_GET_DEPT_USERS,
  ORG_SET_NEW_PWD,
  ORG_UPDATE,
  ORG_DEL_EMPLOEE_BOSS

} from '../actions/org'
import { AUTH_LOGOUT } from '../actions/auth'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import { findParent, findNode } from '@/libs/treeUtils.js'
import axios from 'axios'

const state = {
  profile: {},
  structure: [],
  currentDeptUsers: [],
  currentDiv: {}, // Текущий отдел, администрирование структуры
  currentUser: {}, // Текущий пользователь, администрирование структуры
  orgList: [], // список организаций, зарегистрированных в системе
  orgTypesList: [], // Список типов организаций
  orgFormsList: [], // Список организационно-правовых форм организаций
  currentOrg: {}, // текущая организация
  currentOrgDivisionList: [], // список подразделений текущей организации
  currentOrgPositions: [], // список должностей в текущей организации
  currentOrgDepts: [], // список РО в текущей организации
  currentOrgTechadmins: [], // список техадминов в текущей организации
  deptusers: [], // список пользователей с той же ролью в текущей организации
  ordList: []
}

const getters = {
  getOrgProfile: state => state.profile,

  getStructure: state => state.structure,
  getCurrentOrg: state => state.currentOrg,
  getCurrentOrgTechAdmins: state => state.currentOrgTechadmins,
  getOrgTypesList: state => state.orgTypesList,
  getOrgFormsList: state => state.orgFormsList,
  getOrgList: state => state.orgList,
  isOrgProfileLoaded: state => !!state.profile.name,
  getCurrentDiv: state => {
    console.log('module ORG, getter getCurrentDiv called')
    if (state.currentDiv.NODE_ID) {
      console.log('module ORG, getter getCurrentDiv returning current div (ID) ', state.currentDiv.NODE_ID)
      return {
        INST_ID: state.currentDiv.INST_ID,
        ITP_ID: state.currentDiv.NODE_ID,
        PITP: state.currentDiv.PARENT_ID,
        ITP_NAME: state.currentDiv.NODE_NAME,
        ITP_MNEMO: state.currentDiv.ITP_MNEMO,
        isTech: state.currentDiv.isTech
      }
    }
    console.log('module ORG, getter getCurrentDiv returning undefined')
    return undefined
  },
  getCurrentDivNode: state => state.currentDiv,

  getOrgPositions: state => state.currentOrgPositions,

  getOrgDivisions: state => state.currentOrgDivisionList,

  getOrgDepts: state => state.currentOrgDepts,

  getCurrentUser: state => {
    if (state.currentUser.EMP_ID) {
      return state.currentUser
    }
    return undefined
  }

}

const actions = {
  [ORG_GET_STRUCTURE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_GET_STRUCTURE', topic: 'Загрузка структуры организации', error: null })
      console.log('ORG_GET_STRUCTURE action called ', params)
      axios({ url: '/api/org/admin/getOrgStructure.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const deptList = resp.data.data
            commit(ORG_GET_STRUCTURE, { deptList, params })
            dispatch(UI_SUCCESS, { action: 'ORG_GET_STRUCTURE' })
            if (!state.currentOrgDepts.length) {
              dispatch(ORG_GET_DEPTS)
            }
            if (!state.currentOrgPositions.length) {
              dispatch(ORG_GET_POSITIONS)
            }
            resolve(deptList)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_GET_STRUCTURE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_GET_STRUCTURE', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_GET_DEPTS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_GET_DEPTS', topic: 'Загрузка структуры организации', error: null })
      console.log('ORG_GET_DEPTS action called ', params)
      axios({ url: '/api/org/admin/getOrgDepts.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORG_GET_DEPTS' })
            const deptList = resp.data.data
            commit(ORG_GET_DEPTS, deptList)
            resolve(deptList)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_GET_DEPTS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_GET_DEPTS', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_GET_DEPT_USERS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_GET_DEPT_USERS', topic: 'Загрузка структуры организации', error: null })
      console.log('ORG_GET_DEPTS action called ', params)
      axios({ url: '/api/org/admin/getDeptUsers.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORG_GET_DEPT_USERS' })
            const deptUsers = resp.data.data
            commit(ORG_GET_DEPT_USERS, deptUsers)
            resolve(deptUsers)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_GET_DEPT_USERS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_GET_DEPT_USERS', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_GET_POSITIONS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_GET_POSITIONS', topic: 'Загрузка структуры организации', error: null })
      console.log('ORG_GET_STRUCTURE action called ', params)
      axios({ url: '/api/org/admin/getOrgPositions.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const posList = resp.data.data
            commit(ORG_GET_POSITIONS, posList)
            dispatch(UI_SUCCESS, { action: 'ORG_GET_POSITIONS' })
            resolve(posList)
          } else {
            dispatch(UI_SUCCESS, { action: 'ORG_GET_POSITIONS' })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_GET_POSITIONS', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_SET_NEW_PWD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_SET_NEW_PWD action called ', params)
      axios({ url: '/api/org/admin/setNewPassword.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const opResult = resp.data.data
            commit(ORG_SET_NEW_PWD, opResult)
            resolve(opResult)
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_GET_DIVISION_LIST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_GET_DIVISION_LIST action called ', params)
      axios({ url: '/api/org/admin/getOrgDivisions.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newDivision = resp.data.data
            commit(ORG_GET_DIVISION_LIST, newDivision)
            resolve(resp.data.data)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_ADD_DIVISION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_ADD_DIVISION action called ', params)
      axios({ url: '/api/org/admin/addOrgDivision.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            console.log('Division added OK')
            const newDivision = resp.data.data
            commit(ORG_ADD_DIVISION, newDivision)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                resolve(resp.data.data.ITP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_DEL_DIVISION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_DEL_DIVISION action called ', params)
      axios({ url: '/api/org/admin/delOrgDivision.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            console.log('Division added OK')
            var parentDivision = findParent(state.structure[0], state.currentDiv.PARENT_ID)
            if (parentDivision) {
              dispatch(ORG_GET_STRUCTURE, parentDivision)
                .then(() => {
                  commit(ORG_DEL_DIVISION, parentDivision)
                  resolve(parentDivision)
                })
                .catch((err) => {
                  reject(new Error(err))
                })
            } else {
              commit(ORG_DEL_DIVISION, state.currentDiv)
              resolve(state.currentDiv)
            }
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_UPD_DIVISION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_UPD_DIVISION action called ', params)
      axios({ url: '/api/org/admin/updOrgDivision.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            console.log('Division updated OK')
            const updDivision = resp.data.data
            if (updDivision.PITP === state.currentDiv.PARENT_ID) {
              console.log('Parent node not changed, update current node')
              commit(ORG_UPD_DIVISION, updDivision)
              resolve(updDivision)
            } else {
              console.log('Parent node changed, reload current node')
              var parent = findParent(state.structure[0], state.currentDiv.PARENT_ID)
              dispatch(ORG_GET_STRUCTURE, parent)
                .then(() => {
                  console.log('Parent node reloaded')
                  commit(ORG_UPD_DIVISION, {})
                  resolve(updDivision)
                })
                .catch((err) => {
                  reject(err)
                })
            }
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_ADD_POSITION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_ADD_POSITION action called ', params)
      axios({ url: '/api/org/admin/addOrgPosition.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newPosition = resp.data.data
            commit(ORG_ADD_POSITION, newPosition)
            resolve(resp.data.data)
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_UPD_POSITION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_UPD_POSITION action called ', params)
      axios({ url: '/api/org/admin/updOrgPosition.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const updPosition = resp.data.data
            commit(ORG_UPD_POSITION, updPosition)
            resolve(resp.data.data)
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_DEL_POSITION]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_DEL_POSITION action called ', params)
      axios({ url: '/api/org/admin/delOrgPosition.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORG_DEL_POSITION, params)
            resolve(resp.data.data)
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_ADD_EMPLOEE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_ADD_EMPLOEE action called ', params)
      axios({ url: '/api/org/admin/addOrgEmploee.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newPosition = resp.data.data
            commit(ORG_ADD_EMPLOEE, newPosition)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_LOCK_EMPLOEE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_LOCK_EMPLOEE action called ', params)
      axios({ url: '/api/org/admin/lockEmployee.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const employee = resp.data.data
            commit(ORG_LOCK_EMPLOEE, employee)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_ADD_USER_CONTACT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_ADD_USER_CONTACT', topic: 'Добавление контакта', error: null })
      console.log('ORG_ADD_USER_CONTACT action called ', params)
      axios({ url: '/api/org/admin/addUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'ORG_ADD_USER_CONTACT' })
            commit(ORG_ADD_USER_CONTACT, newContact)
            resolve(newContact)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_ADD_USER_CONTACT', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_ADD_USER_CONTACT', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_UPD_USER_CONTACT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_UPD_USER_CONTACT', topic: 'Обновление контакта', error: null })
      console.log('ORG_UPD_USER_CONTACT action called ', params)
      axios({ url: '/api/org/admin/updUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'ORG_UPD_USER_CONTACT' })
            commit(ORG_UPD_USER_CONTACT, newContact)
            resolve(newContact)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_UPD_USER_CONTACT', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_UPD_USER_CONTACT', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_DEL_USER_CONTACT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_DEL_USER_CONTACT', topic: 'Удаление контакта', error: null })
      console.log('ORG_DEL_USER_CONTACT action called ', params)
      axios({ url: '/api/org/admin/delUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const respContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'ORG_DEL_USER_CONTACT' })
            commit(ORG_DEL_USER_CONTACT, respContact)
            resolve(respContact)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_DEL_USER_CONTACT', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_DEL_USER_CONTACT', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_UPD_EMPLOEE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_UPD_EMPLOEE action called ', params)
      axios({ url: '/api/org/admin/updEmploee.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORG_UPD_EMPLOEE, resp.data.data)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .finally(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_SEND_CREDENTIALS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_SEND_CREDENTIALS action called ', params)
      dispatch(UI_REQUEST, { action: 'ORG_SEND_CREDENTIALS', topic: 'Отправка запроса', error: null })
      axios({ url: '/api/org/admin/sendCredentials.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORG_SEND_CREDENTIALS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'ORG_SEND_CREDENTIALS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_SEND_CREDENTIALS', result: resp.data.error })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_SEND_CREDENTIALS', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_MOVE_EMPLOEE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_MOVE_EMPLOEE action called ', params)
      axios({ url: '/api/org/admin/moveEmploee.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORG_MOVE_EMPLOEE, resp.data.data)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                var node = findNode(state.structure[0], resp.data.data.ITP_ID)
                console.log('Parent node is', node)
                if (node) {
                  dispatch(ORG_GET_STRUCTURE, node)
                }
              })
              .finally(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_DEL_EMPLOEE_BOSS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_DEL_EMPLOEE_BOSS', topic: 'Удаление руководителя сотрудника', error: null })
      axios({ url: '/api/org/admin/delEmploeeBoss.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORG_DEL_EMPLOEE_BOSS' })
            commit(ORG_DEL_EMPLOEE_BOSS, params)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_DEL_EMPLOEE_BOSS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_DEL_EMPLOEE_BOSS', result: err })
          reject(err)
        })
    }),
  [ORG_SET_PO_USER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_SET_PO_USER action called ', params)
      axios({ url: '/api/org/admin/setOrgUserPO.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const poUser = resp.data.data
            commit(ORG_SET_PO_USER, poUser)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_LOCK_PO_USER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('ORG_LOCK_PO_USER action called ', params)
      axios({ url: '/api/org/admin/lockPOUser.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const poUser = resp.data.data
            commit(ORG_LOCK_PO_USER, poUser)
            dispatch(ORG_GET_STRUCTURE, state.currentDiv)
              .then(() => {
                resolve(resp.data.data.EMP_ID)
              })
          } else {
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_GET_DIV_USERS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      if (typeof state.currentDiv.ITP_ID === 'undefined') {
        reject(new Error('Не установлено текущее подразделение'))
        return
      }
      var reqParams = {
        ITP_ID: state.currentDiv.ITP_ID,
        PITP: state.currentDiv.PITP
      }
      axios({ url: '/api/org/admin/getDivStaff.php', data: reqParams, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const deptUsersList = resp.data.data
            commit(ORG_GET_DIV_USERS, deptUsersList)
          }
          resolve(resp.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_GET_TECHADMINS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      if (typeof state.currentOrg.INST_ID === 'undefined') {
        reject(new Error('Не установлена текущая организация'))
        return
      }
      var reqParams = {
        INST_ID: state.currentOrg.INST_ID
      }
      axios({ url: '/api/org/admin/getOrgTechadmins.php', data: reqParams, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const orgTAList = resp.data.data
            commit(ORG_GET_TECHADMINS, orgTAList)
          }
          resolve(resp.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_PROFILE_REQUEST]: ({ commit, dispatch }, org) =>
    new Promise((resolve, reject) => {
      console.log('org getting profile for ', org)
      axios({ url: '/api/org/getprofile.php', data: org, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            // commit(AUTH_SET_SIGNATURE, resp.data.signature)
            commit(ORG_PROFILE_REQUEST, resp.data.data)
            resolve(resp.data)
          } else {
            if (resp.data.error_code < 0) {
              dispatch(AUTH_LOGOUT)
            } else {
              reject(new Error(resp.error_text))
            }
          }
        })
        .catch((err) => {
          reject(new Error(err))
          dispatch(AUTH_LOGOUT)
            .finally(() => {
              reject(new Error('Ошибка получения профиля организации: ' + err))
            })
        })
    }),
  [ORG_GET_ORG]: ({ commit, dispatch }, org) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_GET_ORG', topic: 'Загрузка организации', error: null })
      console.log('ORG_GET_ORG action called with params ', org)
      axios({ url: '/api/org/getOrgProfile.php', data: org, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(ORG_SET_ORG, resp.data.data)
              .then(() => {
                dispatch(UI_SUCCESS, { action: 'ORG_GET_ORG' })
                resolve(resp.data.data)
              })
              .catch((err) => {
                dispatch(UI_ERROR, { action: 'ORG_GET_ORG', result: err })
                reject(err)
              })
          } else {
            dispatch(UI_ERROR, { action: 'ORG_GET_ORG', result: resp.data.error_text })
            reject(resp.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_GET_ORG', result: err })
          reject(err)
        })
    }),
  [ORG_FREE_DATA]: ({ commit }) =>
    new Promise((resolve) => {
      commit(ORG_FREE_DATA)
      resolve('success')
    }),
  [ORG_TYPES_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/org/getOrgTypes.php', data: params, method: 'POST' })
        .then(resp => {
          commit(ORG_TYPES_REQUEST, resp.data.data)
          resolve(resp.data.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),

  [ORG_FORMS_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/org/getOrgForms.php', data: params, method: 'POST' })
        .then(resp => {
          commit(ORG_FORMS_REQUEST, resp.data.data)
          resolve(resp.data.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_UPDATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/org/regRequests/updateOrgProfile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const updRes = resp.data.data
            commit(ORG_UPDATE, updRes)
            commit(ORG_SET_ORG, updRes)
          }
          resolve(resp.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),

  [ORG_LIST_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/org/getOrgList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const ordList = resp.data.data
            commit(ORG_LIST_REQUEST, ordList)
          }
          resolve(resp.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_SET_DIVISION]: ({ commit }, divisionItem) =>
    new Promise((resolve) => {
      commit(ORG_SET_DIVISION, divisionItem)
      resolve()
    }),
  [ORG_SET_ORG]: ({ commit }, requestItem) =>
    new Promise((resolve) => {
      commit(ORG_SET_ORG, requestItem)
      resolve()
    }),
  [ORG_REGISTER_REQUEST]: ({ commit, dispatch }, regcard) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/org/register.php', data: regcard, method: 'POST' })
        .then(resp => {
          resolve(resp.data)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    }),
  [ORG_ADD_USER_ROLE]: ({ commit, dispatch }, regcard) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_ADD_USER_ROLE', topic: 'Добавление роли пользователя', error: null })
      axios({ url: '/api/org/admin/addUserRole.php', data: regcard, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORG_ADD_USER_ROLE' })
            commit(ORG_ADD_USER_ROLE, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_ADD_USER_ROLE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_ADD_USER_ROLE', result: err })
          reject(new Error(err))
        })
    }),
  [ORG_UPD_USER_ROLE]: ({ commit, dispatch }, regcard) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORG_UPD_USER_ROLE', topic: 'Добавление роли пользователя', error: null })
      axios({ url: '/api/org/admin/updUserRole.php', data: regcard, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORG_UPD_USER_ROLE' })
            commit(ORG_UPD_USER_ROLE, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORG_UPD_USER_ROLE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORG_UPD_USER_ROLE', result: err })
          reject(new Error(err))
        })
    })
}

const mutations = {
  [ORG_PROFILE_REQUEST]: state => {
    state.status = 'loading'
  },
  [ORG_PROFILE_REQUEST]: (state, resp) => {
    console.log('ORG_PROFILE_REQUEST mutation called, payload', resp)
    state.profile = resp
  },
  [ORG_PROFILE_UPDATE]: state => {
    state.status = 'loading'
  },
  [ORG_GET_STRUCTURE]: (state, resp) => {
    console.log('ORG_GET_STRUCTURE mutation called, payload', resp)
    if (!state.structure.length || resp.params.PARENT_ID === -1) {
      console.log('Current structure is empty or root node called, adding', resp.deptList)
      state.structure = resp.deptList
    } else {
      console.log('Current structure is NOT empty:', state.structure, ' adding ', resp.deptList)
      if (resp.params.children instanceof Array) {
        console.log('Returned value contains children', resp.deptList)
        resp.params.children.splice(0, resp.params.children.length)
        resp.params.children.push(...resp.deptList)
        state.currentDiv = resp.params
      }
    }
  },
  [ORG_CLEAR_STRUCTURE]: () => {
    console.log('ORG_CLEAR_STRUCTURE mutation called')
    state.currentDiv = {}
    state.currentOrg = {}
    state.currentUser = {}
    state.structure.splice(0, state.structure.length)
  },
  [ORG_GET_DEPTS]: (state, resp) => {
    console.log('ORG_GET_DEPTS mutation called, payload', resp)
    state.currentOrgDepts = resp
  },
  [ORG_GET_POSITIONS]: (state, resp) => {
    console.log('ORG_GET_POSITIONS mutation called, payload', resp)
    state.currentOrgPositions = resp
  },
  [ORG_SET_NEW_PWD]: (state, resp) => {
    console.log('ORG_SET_NEW_PWD mutation called, payload', resp)
  },
  [ORG_ADD_DIVISION]: (state, resp) => {
    console.log('ORG_ADD_DIVISION mutation called, payload', resp)
    var divIdx = state.currentOrgDivisionList.findIndex(item => item.ITP_ID === resp.ITP_ID)
    if (divIdx !== -1) {
      state.currentOrgDivisionList.push(resp)
    }
  },
  [ORG_DEL_DIVISION]: (state, resp) => {
    console.log('ORG_DEL_DIVISION mutation called, payload', resp)
    state.currentDiv = resp
  },
  [ORG_GET_DIVISION_LIST]: (state, resp) => {
    console.log('ORG_GET_DIVISION_LIST mutation called, payload', resp)
    state.currentOrgDivisionList = resp
  },
  [ORG_UPD_DIVISION]: (state, resp) => {
    console.log('ORG_UPD_DIVISION mutation called, payload', resp)
    if (resp.ITP_ID) {
      if (state.currentDiv) {
        state.currentDiv.NODE_NAME = resp.ITP_NAME
        state.currentDiv.ITP_MNEMO = resp.ITP_MNEMO
      }
    } else {
      console.log('Mutation ORG_UPD_DIVISION detected null responce, clearing current node')
      state.currentDiv = resp
    }
  },
  [ORG_ADD_POSITION]: (state, resp) => {
    console.log('ORG_ADD_POSITION mutation called, payload', resp)
    state.currentOrgPositions.push(resp)
  },
  [ORG_UPD_POSITION]: (state, resp) => {
    console.log('ORG_UPD_POSITION mutation called, payload', resp)
    var posIndex = state.currentOrgPositions.findIndex(pos => pos.IPOS_ID === resp.IPOS_ID)
    if (posIndex !== -1) {
      console.log('Position found, ', posIndex)
      state.currentOrgPositions.splice(posIndex, 1, resp)
    } else {
      console.log('Position NOT found')
    }
  },
  [ORG_DEL_POSITION]: (state, resp) => {
    console.log('ORG_DEL_POSITION mutation called, payload', resp)
    var posIndex = state.currentOrgPositions.findIndex(pos => pos.IPOS_ID === resp.IPOS_ID)
    if (posIndex !== -1) {
      console.log('Position found, ', posIndex)
      state.currentOrgPositions.splice(posIndex, 1)
    } else {
      console.log('Position NOT found')
    }
  },
  [ORG_ADD_EMPLOEE]: (state, resp) => {
    console.log('ORG_ADD_EMPLOEE mutation called, payload', resp)
    /*
    if (state.currentDiv.NODE_ID) {
      var node = Object.assign({}, resp)
      node.NODE_NAME = resp.FIO
      node.NODE_ID = resp.EMP_ID + '_EMP'
      node.isUser = true
      node.PARENT_ID = state.currentDiv.NODE_ID
      console.log('Trying to push child to current node ', state.currentDiv)
      state.currentDiv.children.push(node)
    } */
  },
  [ORG_LOCK_EMPLOEE]: (state, resp) => {
    console.log('ORG_LOCK_EMPLOEE mutation called, payload', resp)
    state.currentUser = {}
  },
  [ORG_UPD_EMPLOEE]: (state, resp) => {
    console.log('ORG_UPD_EMPLOEE mutation called, payload', resp)
  },
  [ORG_MOVE_EMPLOEE]: (state, resp) => {
    console.log('ORG_MOVE_EMPLOEE mutation called, payload', resp)
    state.currentUser = {}
  },
  [ORG_SEND_CREDENTIALS]: (state, resp) => {
    console.log('ORG_SEND_CREDENTIALS mutation called, payload', resp)
  },
  [ORG_ADD_USER_CONTACT]: (state, resp) => {
    console.log('ORG_ADD_USER_CONTACT mutation called, payload', resp)
    if (state.currentUser.EMP_ID) {
      state.currentUser.CONTACTS.push(resp)
    }
  },
  [ORG_UPD_USER_CONTACT]: (state, resp) => {
    console.log('ORG_UPD_USER_CONTACT mutation called, payload', resp)
    var contIndex = state.currentUser.CONTACTS.findIndex(item => item.CONT_ID === resp.CONT_ID)
    if (contIndex !== -1) {
      state.currentUser.CONTACTS.splice(contIndex, 1, resp)
    }
  },
  [ORG_DEL_USER_CONTACT]: (state, resp) => {
    console.log('ORG_DEL_USER_CONTACT mutation called, payload', resp)
    var contIndex = state.currentUser.CONTACTS.findIndex(item => item.CONT_ID === resp.CONT_ID)
    if (contIndex !== -1) {
      state.currentUser.CONTACTS.splice(contIndex, 1)
    }
  },
  [ORG_SET_USER_CONTACT_MAIN]: (state, resp) => {
    console.log('ORG_SET_USER_CONTACT_MAIN mutation called, payload', resp)
    if (state.currentUser.EMP_ID) {
      console.log('currentUser is set, mapping contacts')
      state.currentUser.CONTACTS.map(item => {
        if (item.CONT_TYPE === resp.CONT_TYPE) {
          if (item.CONT_ID !== resp.CONT_ID) { item.CONT_IS_GEN = '0' } else { item.CONT_IS_GEN = '1' }
        }
        return item
      })
    } else {
      console.log('Что-то пошло не так: нет активного пользователя!')
    }
  },
  [ORG_SET_PO_USER]: (state, resp) => {
    console.log('ORG_SET_PO_USER mutation called, payload', resp)
  },
  [ORG_LOCK_PO_USER]: (state, resp) => {
    console.log('ORG_LOCK_PO_USER mutation called, payload', resp)
    state.currentUser.IS_ACTIVE_USR = resp.IS_ACTIVE_USR
  },
  [ORG_GET_DIV_USERS]: (state, resp) => {
    console.log('ORG_GET_DIV_USERS mutation called, payload', resp)
  },
  [ORG_GET_TECHADMINS]: (state, resp) => {
    console.log('ORG_GET_TECHADMINS mutation called, payload', resp)
    state.currentOrgTechadmins = resp
  },
  [ORG_GET_DEPT_USERS]: (state, resp) => {
    console.log('ORG_GET_DEPT_USERS mutation called, payload', resp)
    state.deptusers = resp
  },
  [ORG_FREE_DATA]: state => {
    state.status = ''
    state.lastError = ''
    state.profile = {}
    state.structure.splice(0, state.structure.length)
    state.currentDeptUsers.splice(0, state.currentDeptUsers.length)
    state.currentDiv = {} // Текущий отдел, администрирование структуры
    state.currentUser = {} // Текущий пользователь, администрирование структуры
    state.orgList.splice(0, state.orgList.length) // список организаций, зарегистрированных в системе
    state.orgTypesList.splice(0, state.orgTypesList.length) // Список типов организаций
    state.orgFormsList.splice(0, state.orgFormsList.length) // Список организационно-правовых форм организаций
    state.currentRegRequest = {} // текущий запрос на регистрацию, с которым осуществлются все действия
    state.currentOrgDivisionList.splice(0, state.currentOrgDivisionList.length) // список подразделений текущей организации
    state.currentOrgPositions.splice(0, state.currentOrgPositions.length) // список должностей в текущей организации
    state.currentOrgDepts.splice(0, state.currentOrgDepts.length) // список РО в текущей организации
    state.currentOrg = {} // текущая организация
    state.deptusers.splice(0, state.deptusers.length) // список пользователей с той же ролью в текущей организации
    state.ordList.splice(0, state.ordList.length)
  },

  [ORG_SET_USER]: (state, userItem) => {
    console.log('ORG_SET_USER mutation called, payload', userItem)
    state.currentUser = userItem
  },
  [ORG_SET_DIVISION]: (state, divisionItem) => {
    console.log('ORG_SET_DIVISION mutation called, payload', divisionItem)
    state.currentDiv = divisionItem
  },
  [ORG_SET_ORG]: (state, orgItem) => {
    console.log('ORG_SET_ORG mutation called, payload', orgItem)
    state.currentOrg = orgItem
  },

  [ORG_UPDATE]: (state, resp) => {
    console.log('ORG_UPDATE mutation called. RESP is ', resp)
    // eslint-disable-next-line eqeqeq
    var orgIndex = state.orgList.findIndex(org => org.INST_ID == resp.INST_ID)
    console.log('Tryed to find in current orglist item with INST_ID ', resp.INST_ID, 'found ', orgIndex)
    if (orgIndex !== -1) {
      console.log('Org found, ', orgIndex)
      state.orgList.splice(orgIndex, 1, resp)
    } else {
      console.log('Org NOT found')
    }
  },

  [ORG_TYPES_REQUEST]: (state, resp) => {
    console.log('ORG_TYPES_REQUEST mutation called. RESP is ', resp)
    state.orgTypesList = resp
  },
  [ORG_FORMS_REQUEST]: (state, resp) => {
    console.log('ORG_FORMS_REQUEST mutation called. RESP is ', resp)
    state.orgFormsList = resp
  },
  [ORG_LIST_REQUEST]: (state, resp) => {
    console.log('ORG_LIST_REQUEST_SUCCESS mutation called. RESP is ', resp)
    state.orgList = resp
  },
  [ORG_ADD_USER_ROLE]: (state, resp) => {
    console.log('ORG_ADD_USER_ROLE mutation called', resp)
  },
  [ORG_UPD_USER_ROLE]: (state, resp) => {
    console.log('ORG_UPD_USER_ROLE mutation called', resp)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
